import { useMemo } from 'react'
import { calcScotch } from './ggScotch.js'
import { sampleTeams } from './ggSamplePlayers.js'

// G-Scotch — isolated sandbox. 2 teams of 2, alternate-shot match play on the
// team's per-hole total. calcScotch ported verbatim from GolfGamesScorecard.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GScotch() {
  const [t1, t2] = useMemo(() => sampleTeams().slice(0, 2), [])
  const r = useMemo(() => calcScotch(t1, t2), [t1, t2])
  const nm = (t) => t.map((p) => p.name.split(' ')[0]).join(' & ')
  const won = (side) => r.results.filter((x) => x === side).length

  return (
    <div className="card">
      <p className="text-sm mb-3">Winner: <b>{r.winner}</b>{r.t1Up !== 0 ? ` (${Math.abs(r.t1Up)} up)` : ''}</p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Team', 'Holes won'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>
          <tr><td style={cell}>Team 1 · {nm(t1)}</td><td style={cell}><b>{won('t1')}</b></td></tr>
          <tr><td style={cell}>Team 2 · {nm(t2)}</td><td style={cell}><b>{won('t2')}</b></td></tr>
          <tr><td style={cell}>Halved</td><td style={cell}>{won('halved')}</td></tr>
        </tbody>
      </table>
    </div>
  )
}
